import { render, staticRenderFns } from "./c_checkbox_group.vue?vue&type=template&id=0b427a1b&scoped=true"
import script from "./c_checkbox_group.vue?vue&type=script&lang=js"
export * from "./c_checkbox_group.vue?vue&type=script&lang=js"
import style0 from "./c_checkbox_group.vue?vue&type=style&index=0&id=0b427a1b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b427a1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b427a1b')) {
      api.createRecord('0b427a1b', component.options)
    } else {
      api.reload('0b427a1b', component.options)
    }
    module.hot.accept("./c_checkbox_group.vue?vue&type=template&id=0b427a1b&scoped=true", function () {
      api.rerender('0b427a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_checkbox_group.vue"
export default component.exports